import throttle from '../../vendor/lodash-es/throttle';

class Quotes {
	constructor( node ) {
		this.node = node;
		this.quotes = Array.from(this.node.querySelectorAll('.quote'));
		window.addEventListener('load', this.resize.bind(this));
		window.addEventListener('resize', throttle(this.resize.bind(this), 10));
	}

	resize() {
		this.quotes.forEach(( quote ) => {
			quote.style.minHeight = '';
		});

		let height = Math.max.apply(null, this.quotes.map(( quote ) => quote.offsetHeight));

		this.quotes.forEach(( quote ) => {
			quote.style.minHeight = `${height}px`;
		});
	}
}

export default Quotes;
